import { Dispatch } from 'redux';
import { apiAction } from '../../../TCSMApp/global/ducks/base-api';
import { ApiAction, HttpMethods } from '../../../TCSMApp/global/models/api-model';
import { KeyValuePair } from '../../../TCSMApp/pages/arc/models/arc-epi-props';
import { ParishFilters, ParishSearchSort } from '../components/parish/parish-model';
import { ApiEndpoint } from '../constants/api-endpoints';

export const parishNameAutocompletePath = 'search/parish_name.json';
export const parishLocationAutocompletePath = 'search/parish_location.json';
export const parishSearchPath = 'search/parish.json';
export const parishDetailPath = 'parishes/';

export function QuickSearchByName(
	partialName: string, 
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any, 
	onFailure?: (dispatch?: Dispatch<any>) => any,
	): ApiAction {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.ecdPlusPrc}${parishNameAutocompletePath}?val=${partialName}`,		
		onSuccess,
		onFailure,
	});
}

export function QuickSearchByLocation(
	partialName: string, 
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any, 
	onFailure?: (dispatch?: Dispatch<any>) => any,
	): ApiAction {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.ecdPlusPrc}${parishLocationAutocompletePath}?val=${partialName}`,		
		onSuccess,
		onFailure,
	});
}

export function Search(
	filters: ParishFilters, 
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any, 
	onFailure?: (dispatch?: Dispatch<any>) => any,
	): ApiAction {
	
	const formData = new FormData();		

	if (filters?.location){
		formData.append('location', filters?.location?.trim());
	}

	if (filters?.name){
		formData.append('name', filters?.name?.trim());
	}

	if (filters?.type){
		formData.append('type', filters?.type?.trim());
	}

	if (filters?.sort){
		formData.append('sort', filters?.sort);
	}

	if (filters?.zip_code){
		formData.append('zip_code', filters?.zip_code?.trim());
	}	

	return apiAction({
		method: HttpMethods.POST,
		payloadData: null,
		url: `${ApiEndpoint.ecdPlusPrc}${parishSearchPath}`,		
		formData,
		contentType: 'multipart/form-data',
		onSuccess,
		onFailure,
	});
}

export function GetDetail(
	parishId: string | number, 
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any, 
	onFailure?: (dispatch?: Dispatch<any>) => any,
	): ApiAction {
	return apiAction({
		method: HttpMethods.GET,		
		url: `${ApiEndpoint.ecdPlusPrc}${parishDetailPath}${parishId}.json`,		
		onSuccess,
		onFailure,
	});
}

export const apiParishTypeOptions : string[] = [
			'Campus Ministry',
			'Cathedral',
			'Chapel',
			'Chaplaincy',
			'Cluster',
			'College Chapel',
			'COO',
			'Diocese',
			'ECCC',
			'Health Agency',
			'Historical Church',
			'Inactive',
			'Mission',
			'National Organization',
			'Nursing Home',
			'Other',
			'Parish',
			'Preaching Station',
			'Prison Ministry',
			'Retirement Home',
			'School',
			'Seminary',
			'Special Needs Ministry',
			'Summer Chapel',
			];

function mapParishType(value: string, mapList: KeyValuePair[]): string {

	if (mapList?.length > 0){		
		return mapList.find(v => value?.toLocaleLowerCase() === v?.key.toLocaleLowerCase())?.value || value;
	}
	
	return value;
}

export function GetParishTypeOptions(parishTypeMapping: KeyValuePair[]){
	return apiParishTypeOptions.map(item => { return { value: item, text: mapParishType(item, parishTypeMapping) }; });
}

const apiOrderByOptions : string[][] = [
	[ ParishSearchSort.NameAsc, 'Parish Name A-Z'],
	[ ParishSearchSort.NameDesc, 'Parish Name Z-A'],
	[ ParishSearchSort.CityAsc, 'City A-Z'],
	[ ParishSearchSort.CityDesc, 'City Z-A'],
	[ ParishSearchSort.StateAsc, 'State A-Z'],
	[ ParishSearchSort.StateDesc, 'State Z-A'],
	[ ParishSearchSort.ZipCodeAsc, 'Zip Code A-Z'],
	[ ParishSearchSort.ZipCodeDesc, 'Zip Code Z-A'],
	];

export function GetParishOrderByOptions(orderByMapping: KeyValuePair[]){
	return apiOrderByOptions.map(item => { return { value: item[0], text: mapParishType(item[1], orderByMapping) }; });
}
